module.exports = __webpack_public_path__ + "assets/b9a60ad6361a20fcdc545da37a361d4f.svg";